<app-auth-shell title="Confirmando sua conta" subtitle="Aguarde um instante enquanto validamos o link de confirmação.">
  <div class="auth-confirm">
    <div class="auth-confirm__spinner" role="status" aria-label="Confirmando conta"></div>
  </div>
</app-auth-shell>
